import { memo, Suspense } from 'react';

import { DuoCardsPair } from '@/features/duos/components/duoCardsPair';
import { ValorantRankIcon } from '@/features/games/valorant/components/valorantRankIcon';
import { useGetValorantPlayer } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { Skeleton } from '@/shared/components/ui/skeleton';
import type { Rarity } from '@/shared/types/rarity';

interface RankIconProps {
  riotPuuid: string;
}

function RankIcon({ riotPuuid }: RankIconProps) {
  const { data } = useGetValorantPlayer({
    puuid: riotPuuid,
    options: {
      select: data => data.player.rank,
    },
  });

  return <ValorantRankIcon rank={data} className="size-6" />;
}

function RankIconSkeleton() {
  return <Skeleton className="size-8 rounded-full" />;
}

export interface DuoActivityCardsPairProps {
  leftRarity: Rarity;
  rightRarity: Rarity;
  leftRiotPuuid: string | undefined;
  rightRiotPuuid: string | undefined;
  leftImage: string;
  rightImage: string;
  leftName: string;
  rightName: string;
  leftIsPremium?: boolean;
  rightIsPremium?: boolean;
  className?: string;
}

export const DuoActivityCardsPair = memo(function DuoActivityCardsPair(
  props: DuoActivityCardsPairProps,
) {
  const {
    leftRarity,
    rightRarity,
    leftRiotPuuid,
    rightRiotPuuid,
    leftImage,
    rightImage,
    leftName,
    rightName,
    leftIsPremium,
    rightIsPremium,
    className,
  } = props;

  return (
    <DuoCardsPair
      leftRarity={leftRarity}
      rightRarity={rightRarity}
      leftRank={
        leftRiotPuuid ? (
          <Suspense fallback={<RankIconSkeleton />}>
            <RankIcon riotPuuid={leftRiotPuuid} />
          </Suspense>
        ) : null
      }
      rightRank={
        rightRiotPuuid ? (
          <Suspense fallback={<RankIconSkeleton />}>
            <RankIcon riotPuuid={rightRiotPuuid} />
          </Suspense>
        ) : null
      }
      leftImage={leftImage}
      rightImage={rightImage}
      leftName={leftName}
      rightName={rightName}
      leftIsPremium={leftIsPremium}
      rightIsPremium={rightIsPremium}
      className={className}
    />
  );
});
